import { DRAWIO_EXPORT_OPTIONS } from "./diagramConstants"

export type DiagramExportAction = {
  format: "xmlsvg"
}

export const buildDiagramExportAction = (): DiagramExportAction => ({
  ...DRAWIO_EXPORT_OPTIONS,
})

export const isValidDiagramExportData = (data: unknown): data is { data: string; xml?: string } => {
  if (!data || typeof data !== "object") return false

  const record = data as Record<string, unknown>
  return typeof record.data === "string" && record.data.startsWith("data:")
}
